import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { MdSearch as IconSearch } from 'react-icons/md';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import {
  Button, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon,
  Label, Modal, ModalBody, ModalFooter, ModalHeader, Row
} from 'reactstrap';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { SizeMe } from 'react-sizeme';

/* Material-ui */
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button as ButtonMui } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';


/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

/* Routes */
import { domainIsTenant, S, domain } from '../../routes/routes'

/* Json */
import { safeDeepGet, safeDeepGetWithType, safeGetWithType } from 'iotera-base/json'

/* Redux */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

/* Sagas Actions */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

import { SubViewHeader } from '../../lib/components/subHeader';
import { ComponentTable } from '../../custom/table';
import Result from 'iotera-base/result';
import {
  DEVICE_CAT_LORA, DEVICE_CAT_ZLAN, DEVICE_CAT_KAA,
  DEVICE_CAT_MQTT, DEVICE_CAT_TASMOTA, DEVICE_CAT_UI, DEVICE_CAT_BIVOCOM, DEVICE_CAT_FRIENDCOM, DEVICE_CAT_IOTERA,
  DEVICE_CAT_EMMA, DEVICE_CAT_IMOU_CAMERA
} from '../../lib/components/Preference';
import { setDeviceEmpty } from '../../testActions';
import { store } from '../../testStore';
import { isArray, isObject, isFunction, isEmpty } from 'iotera-base/object';
import IoteraClass from '../../lib/components/react/react-class';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const ADD = "ADD";
const INIT_DEVICES = "INIT_DEVICES"
const INIT_TAGS = "INIT_TAGS"
const DELETE_DUM = "DELETE_DUM"
const DELETE_KAA = "DELETE_KAA"
const DELETE_ZLAN = "DELETE_ZLAN"
const DELETE_MQTT = "DELETE_MQTT"
const DELETE_TASMOTA = "DELETE_TASMOTA"
const DELETE_UI = "DELETE_UI"
const DELETE_BIVOCOM = "DELETE_BIVOCOM"
const DELETE_FRIENDCOM = "DELETE_FRIENDCOM"
const DELETE_IOTERA = "DELETE_IOTERA"
const DELETE_LORA = "DELETE_LORA"
const DELETE_EMMA = "DELETE_EMMA"
const DELETE_IMOU_CAMERA = "DELETE_IMOU_CAMERA"
const RELOAD = "RELOAD"
const WKEY = "DEVICE_LIST";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class DeviceListBlock extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      operation: false,
      search: "",
      filter: false,
      searchFilter: false,
      deviceList: props.data,
      filters: {
        deviceType: [],
        status: []
      },
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    }
    this.resize = this.resize.bind(this);
    this.finalData = this.finalData.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete(deviceId, deviceType) {
    const _this = this
    const _props = _this.props
    let handleDelete = safeDeepGetWithType(_props, ['handleDelete']);
    if (isFunction(handleDelete)) {
      handleDelete(deviceId, deviceType)
      _this.setState({
        filter: false,
        searchFilter: false,
        filters: {
          deviceType: [],
          status: []
        }
      })
    }
  }

  finalData(search, filter) {
    const _props = this.props
    const regExpSearching = new RegExp(search, 'i')
    const allDevice = safeDeepGet(_props, ['data']);
    // SIMPLIFIED
    let deviceToShow = allDevice.filter(
      d =>
        // for searching
        (d.name.search(regExpSearching) !== -1 || d.id.search(regExpSearching) !== -1 || d.serial.search(regExpSearching) !== -1) &&
        // for filter
        (
          (filter.status.every(r => d.status.indexOf(r) >= 0)) &&
          (filter.deviceType.every(r => d.deviceType.indexOf(r) >= 0))
        )
    )
    return deviceToShow;
  }

  resize(event) {
    this.setState({
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    })
  }

  handleChange = event => {
    this.setState({ search: event.target.value })
  }

  handleKeyUp = event => {
    const _this = this
    const _state = _this.state
    if (event.key === "Enter") {
      _this.handleSearchFilter()
    }
    if (((event.key === "Backspace") || (event.key === "Delete")) && _state.search.length === 0) {
      _this.handleSearchFilter()
    }
  }

  handleCheckedDevice = (value) => {
    this.setState({ operation: value })
  }

  handleSearchFilter = () => {
    const _this = this
    const _state = _this.state
    let devices = []
    const { search, filters } = _state
    devices = _this.finalData(search, filters);
    if (search.length === 0) {
      _this.setState({ deviceList: devices, searchFilter: false });
    } else {
      _this.setState({ deviceList: devices, searchFilter: true });
    }
  }

  submitHandler(e) {
    e.preventDefault();
  }

  handleFilter = (value, action, parameter) => {
    const _this = this
    const _state = _this.state
    let newState = Object.assign({}, _state);
    let filters = []
    if (isArray(value)) {
      value.forEach((filter) => {
        filters.push(filter.value)
      })
    } else if (isObject(value)) {
      filters.push(value.value)
    }
    newState.filters[parameter] = filters;
    let devices = [];
    let finalFilter = true;
    if ((newState.filters.status.length === 0) && (newState.filters.deviceType.length === 0)) {
      finalFilter = false;
    }
    const { search } = _state
    devices = _this.finalData(search, newState.filters);
    _this.setState({ deviceList: devices, filter: finalFilter });
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    window.onresize = _this.resize;
    let data = safeDeepGet(_props, ['data'], []);
    const { filter, searchFilter, deviceList, operation, search, custom } = _state
    if (filter || searchFilter) {
      data = deviceList
    }
    let operationButtonGroup = "";
    if (operation) {
      operationButtonGroup = <FormGroup row className="the-operation">
        <Label sm={1}>Tindakan</Label>
        <Col sm={11}>
          <div className="button-line">
            <div><Button color="primary" className="mb-2 margin-20" outline>Hapus device</Button></div>
            <RebootDeviceModal data={_props.data} />
            <ControlDeviceModal data={_props.data} />
          </div>
        </Col>
      </FormGroup>;
    }
    const length = data.length;
    if (filter || searchFilter || length > 0) {
      return (
        <div >
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <InputGroup>
                  <Input placeholder="Cari nama atau id atau nomor serial" value={search}
                    onChange={_this.handleChange} onKeyUp={_this.handleKeyUp} type="text" step="1" />
                  <InputGroupAddon addonType="append">
                    <Button onClick={_this.handleSearchFilter}><IconSearch size={16} /></Button>
                  </InputGroupAddon>
                </InputGroup>
              </div>
            </FormGroup>
            <FormGroup >
              <Row>
                <div className="col-md-2" style={{ paddingTop: '6px' }}>
                  <Label>Filter</Label>
                </div>
                <div className={custom} style={{ marginBottom: '6px' }}>
                  <DropdownDeviceList data={_props.data} isDisabled={operation} parameter='status' name='Semua status'
                    onSelectFilter={_this.handleFilter} />
                </div>
                <div className={custom} style={{ marginBottom: '6px' }}>
                  <DropdownDeviceList data={_props.data} isDisabled={operation} parameter='deviceType' name='Semua jenis'
                    onSelectFilter={_this.handleFilter} isMulti={false} />
                </div>
              </Row>
            </FormGroup>
            <ReactCSSTransitionGroup
              transitionName="operation"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={300}>
              {operationButtonGroup}
            </ReactCSSTransitionGroup>
            {length > 0 ?
              <SizeMe>{({ size }) =>
                <div className="table-responsive">
                  <DeviceListTableWR data={data} tags={_props.tags} onCheckedDevice={_this.handleCheckedDevice}
                    tableSize={size} handleDelete={_this.handleDelete} handleAdd={_props.handleAdd} />
                </div>
              }</SizeMe>
              :
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... perangkat tidak ditemukan</div>
              </div>
            }
          </Form>
        </div>
      )
    } else {
      return (
        <div>
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... Perangkat Masih Kosong</div>
                <div style={{ textAlign: 'center' }}>Perangkat yang telah didaftarkan akan ditampilkan disini.</div>
              </div>
            </FormGroup>
          </Form>
        </div>
      )
    }
  }
}

const DeviceBasicTable = ({ data }) => (
  <table className="table">
    <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Serial</th>
      </tr>
    </thead>
    <tbody>
      {data.map((item, i) => <tr key={i}>
        <th scope="row">{i + 1}</th>
        <td>{item.name}</td>
        <td>{item.serial}</td>
      </tr>)}
    </tbody>
  </table>
);

class ControlDeviceModal extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalClass: ''
    }
  }

  toggle = (e, str) => {
    const _this = this
    const _state = _this.state
    const { modal } = _state
    _this.setState({
      modal: !modal,
      modalClass: str
    })
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { modal, modalClass } = _state
    let controlDeviceBody = ''
    let selectedDevices = []
    _props.data.forEach((device, index, devices) => {
      if (device.selected === true) {
        selectedDevices.push({ name: device.name, serial: device.serial })
      }
    })
    controlDeviceBody =
      <div key={selectedDevices}>
        <h6>Perangkat yang akan dikontrol</h6>
        <DeviceBasicTable data={selectedDevices} />
        <h6>Command</h6></div>
    return (
      <div>
        <Button color="primary" onClick={(e) => _this.toggle(e, 'modalFadeInScale')} className="mb-2" outline>Kirim command</Button>{" "}
        <Modal isOpen={modal} toggle={_this.toggle} className={modalClass}>
          <ModalHeader toggle={_this.toggle}>Kontrol device</ModalHeader>
          <ModalBody>
            {controlDeviceBody}
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={_this.toggle}>Kirim command</Button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

class RebootDeviceModal extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalClass: ''
    }
  }

  toggle = (e, str) => {
    const _this = this
    const _state = _this.state
    const { modal } = _state
    _this.setState({
      modal: !modal,
      modalClass: str
    })
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { modal, modalClass } = _state
    let controlDeviceBody = []
    let selectedDevices = []
    _props.data.forEach((device, index, devices) => {
      if (device.selected === true) {
        selectedDevices.push({ name: device.name, serial: device.serial })
      }
    })
    controlDeviceBody.push(
      <div>
        <h6>Perangkat yang akan direboot</h6>
        <DeviceBasicTable data={selectedDevices} />
        <h6>Command</h6></div>)
    return (
      <div>
        <Button color="primary" onClick={(e) => this.toggle(e, 'modalFadeInScale')}
          className="mb-2 margin-20" outline>Reboot</Button>{" "}
        <Modal isOpen={modal} toggle={_this.toggle} className={modalClass}>
          <ModalHeader toggle={_this.toggle}>Kontrol device</ModalHeader>
          <ModalBody>
            {controlDeviceBody}
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={_this.toggle}>Kirim command</Button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const DeviceListTableWR = withRouter(ComponentTable);

export class DropdownDeviceList extends IoteraClass {
  handleFilterChange = (value, action) => {
    const _props = this.props
    _props.onSelectFilter(value, action, _props.parameter);
  }

  render() {
    const _this = this
    const _props = _this.props
    let dropdownItem = []
    let allItem = []
    let data = safeDeepGet(_props, ['data']);
    let parameter = safeDeepGet(_props, ['parameter']);
    if (parameter === 'components') {
      for (let i = 0; i < data.length; i++) {
        let componentsItem = data[i][parameter];
        Object.keys(componentsItem).forEach((key) => {
        })
      }
      Object.keys(data).forEach((key) => {
      })
    } else {
      Object.keys(data).forEach((key) => {
        allItem.push(data[key][parameter])
      })
    }
    allItem = [].concat.apply([], allItem);
    allItem = [...new Set(allItem)];
    for (let j = 0; j < allItem.length; j++) {
      let name = allItem[j];
      if (name === 'on') {
        name = 'Nyala'
      } else if (name === 'off') {
        name = 'Mati'
      }
      dropdownItem.push(
        { label: name, value: allItem[j] },
      )
    }
    let isMulti = safeDeepGetWithType(_props, ['isMulti'], true)
    return (
      <Select styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} menuPortalTarget={document.body}
        isDisabled={_props.isDisabled}
        ref="selectComponent"
        closeMenuOnSelect={!isMulti}
        defaultValue={[]}
        isMulti={isMulti}
        isSearchable
        isClearable
        placeholder={_props.name}
        options={dropdownItem}
        className="basic-multi-select"
        onChange={_this.handleFilterChange}
      />
    )
  }
}

class Devices extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      devices: [],
      openDef: false,
      selectedDevId: '',
      dashName: ''
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleAddDummy = this.handleAddDummy.bind(this)
    this.onRemoveFinished = this.onRemoveFinished.bind(this)
  }

  handleClick() {
    let emptyFirst = setDeviceEmpty();
    store.dispatch(emptyFirst);
    this.props.history.push('.' + S + '_device_add_' + S + 'category')
  };

  handleAddDummy(id) {
    this.setState({ openDef: true, selectedDevId: id });
  }

  handleDelete(deviceId, deviceType) {
    const _props = this.props
    let id = DELETE_DUM;
    if (deviceType === DEVICE_CAT_KAA) {
      id = DELETE_KAA
    } else if (deviceType === DEVICE_CAT_LORA) {
      id = DELETE_LORA
    } else if (deviceType === DEVICE_CAT_ZLAN) {
      id = DELETE_ZLAN
    } else if (deviceType === DEVICE_CAT_MQTT) {
      id = DELETE_MQTT
    } else if (deviceType === DEVICE_CAT_TASMOTA) {
      id = DELETE_TASMOTA
    } else if (deviceType === DEVICE_CAT_UI) {
      id = DELETE_UI
    } else if (deviceType === DEVICE_CAT_BIVOCOM) {
      id = DELETE_BIVOCOM
    } else if (deviceType === DEVICE_CAT_FRIENDCOM) {
      id = DELETE_FRIENDCOM
    } else if (deviceType === DEVICE_CAT_IOTERA) {
      id = DELETE_IOTERA
    } else if (deviceType === DEVICE_CAT_EMMA) {
      id = DELETE_EMMA
    } else if (deviceType === DEVICE_CAT_IMOU_CAMERA) {
      id = DELETE_IMOU_CAMERA
    }
    _props.wSingleRequestCall({
      id,
      body: {
        id: deviceId
      }
    })
  };

  onRemoveFinished(id, result) {
    if (result.code === Result.HTTP.OK) {
      const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
      if (responseResult === Result.SUCCESS) {
        this.setState({
          loading: false
        })
        this.props.showSingleNotification({ message: 'Hapus Perangkat Berhasil', level: 'success' });
        this.props.wSingleRequestCall({
          id: RELOAD,
        })
        return;
      }
    }
    this.setState({
      loading: false
    })
    this.props.showSingleNotification({ message: 'Hapus Perangkat Gagal', position: 'tr', level: 'error' });
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const dit = domainIsTenant(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        requests: {
          [INIT_TAGS]: {
            wparam: { ...dit, path: "/service/web/tag/category/get/all" },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
                _this.setState({
                  tags: safeDeepGetWithType(result, ['body', 'categories'], {})
                })
              },
            }
          },
          [INIT_DEVICES]: {
            wparam: { ...dit, path: "/service/web/device/list/web/filter" },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
                if (result['code'] === 200) {
                } else {
                  _this.setState({ loading: false })
                }
              }
            },
            wreducer: {
              rparse: function (id, result, rpayload) {
                let items = [];
                let devices = safeDeepGet(rpayload, ['devices']);
                for (let i = 0; i < devices.length; ++i) {
                  let device = devices[i];
                  let item = {};
                  let ids = device["id"];
                  let category_text = safeDeepGetWithType(device, ['category_text'], 'Dummy')
                  let category = safeDeepGetWithType(device, ['category'], 0)
                  let firmware = safeDeepGetWithType(device, ['firmware_version'], '1.0')
                  item.id = ids;
                  item.bandwidth = 0;
                  item.length = 1;
                  item.data = 0;
                  item.deviceType = [category_text];
                  item.category = category;
                  item.firmware = firmware;
                  item.name = device["name"];
                  item.selected = false;
                  item.tags = device['tags'];
                  item.serial = device["serial_number"];
                  item.status = [device["online"] ? "on" : "off"];
                  item.online = device["online"];
                  item.last_online_ts = device["last_online_ts"];
                  item.last_offline_ts = device["last_offline_ts"];
                  item.disabled = safeGetWithType(device, 'disabled', false);
                  item.storage = 0;
                  items.push(item);
                }
                const newDevices = {
                  devices: items
                }
                _this.setState({
                  loading: false,
                  devices: items
                })
                return newDevices;
              }
            }
          },
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/application/nav/add/dum"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({ loading: false })
                  // Magic to refresh routes
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_dashboard_list_')
                  _props.showSingleNotification({ message: 'Generate Dashboard Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({ loading: false })
              _props.showSingleNotification({ message: 'Generate Dashboard Gagal', position: 'tr', level: 'error' });
            }
          }
        },
        [DELETE_LORA]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/l/node/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_ZLAN]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/z/node/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_MQTT]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/mqtt/node/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_TASMOTA]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/tasmota/node/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_UI]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/ui/node/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_BIVOCOM]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/b/node/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_FRIENDCOM]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/friendcom/node/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_IOTERA]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/io/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_EMMA]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/emma/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_IMOU_CAMERA]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/imouc/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_KAA]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/k/end/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [DELETE_DUM]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/dum/node/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              _this.onRemoveFinished(id, result);
            }
          }
        },
        [RELOAD]: {
          wparam: { ...dit, path: "/service/web/device/list/web/filter" },
          wcallback: {
            started: function (id) {
              // TODO Loading
              _this.setState({
                loading: true
              })
            }
          },
          wreducer: {
            rparse: function (id, result, rpayload) {
              let items = [];
              let devices = safeDeepGet(rpayload, ['devices']);
              for (let i = 0; i < devices.length; ++i) {
                let device = devices[i];
                let item = {};
                let ids = device["id"];
                let category_text = safeDeepGetWithType(device, ['category_text'], 'Dummy')
                let firmware = safeDeepGetWithType(device, ['firmware_version'], '1.0')
                let category = safeDeepGetWithType(device, ['category'], 0)
                item.id = ids;
                item.bandwidth = 0;
                item.length = 1;
                item.data = 0;
                item.deviceType = [category_text];
                item.category = category;
                item.firmware = firmware;
                item.name = device["name"];
                item.selected = false;
                item.tags = device['tags'];
                item.serial = device["serial_number"];
                item.status = [device["online"] ? "on" : "off"];
                item.storage = 0;
                items.push(item);
              }
              const newDevices = {
                devices: items
              }
              _this.setState({
                loading: false,
                // TODO
                devices: items,
                filter: false,
                searchFilter: false
              })
              return newDevices;
            }
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  handleClose = () => {
    this.setState({ openDef: false, dashName: '', selectedPrefixDef: '' });
  };

  handleChangeDashName = event => {
    this.setState({ dashName: event.target.value })
  }

  handleSubmit = () => {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let { selectedDevId: devId, dashName: name } = _state
    _props.wSingleRequestCall({
      id: ADD,
      body: {
        name,
        device_id: devId,
      }
    });
    _this.setState({ openDef: false, dashName: '', loading: true });
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let { loading, devices } = _state;
    const { openDef } = _state
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Perangkat' subTitle='Seluruh perangkat yang terdaftar di aplikasi ini.' />
          <div className="view-content-dashboard">
            <DeviceListBlock {..._props} data={devices} handleDelete={_this.handleDelete} handleAdd={_this.handleAddDummy} />
            <Dialog
              open={openDef}
              onClose={_this.handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Tambah Dashboard</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Masukkan nama dashboard
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Nama Dashboard"
                  fullWidth
                  onChange={_this.handleChangeDashName}
                />
              </DialogContent>
              <DialogActions>
                <ButtonMui onClick={_this.handleClose} color="primary">
                  Batal
            </ButtonMui>
                <ButtonMui onClick={_this.handleSubmit} variant="contained" color="primary">
                  Tambah
            </ButtonMui>
              </DialogActions>
            </Dialog>
            <Tooltip TransitionComponent={Zoom} title='Tambah Alat' enterDelay={500} >
              <Fab variant="extended" color={'primary'} style={{
                position: 'absolute',
                bottom: 0 * 2,
                right: 20 * 2
              }}
                onClick={(e) => _this.handleClick(e)}
              >
                <AddIcon style={{ marginRight: 8 }} />
                Alat Baru
              </Fab>
            </Tooltip>
          </div>
        </div>
      </Loader>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getMappedRPayload(state, INIT_DEVICES, 'devices'),
    tags: wSelector.getMappedRPayload(state, INIT_TAGS, 'categories')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Devices));